// filepath: forluz/src/components/Publicacoes/components/PublicacaoCard.tsx
import React from "react";
import iconJornal from "../../../assets/img/Capa Publicações - Jornal Forluz_Prancheta 1.png";
import icoAviao from "../../../assets/img/Capa Publicações - Newsletter_Prancheta 1.png";
import icoRentab from "../../../assets/img/capa_pub_rentabilidade_prancheta_1.png";
import icoSorriso from "../../../assets/img/ico-sorrisos.svg";
import { track } from "../../../services/analytics";

interface PublicacaoCardProps {
  item: {
    ID: number;
    Title: string;
    URL: string;
    Descricao: string;
    Data_x0020_Publicacao: string;
  };
}

const PublicacaoCard: React.FC<PublicacaoCardProps> = ({ item }) => {
  const tipoPublicacao = item.URL.includes("/Jornal Forluz/")
    ? "jornal"
    : item.URL.includes("/Newsletter/")
    ? "newsletter"
    : item.URL.includes("/Rentabilidades/")
    ? "rentabilidades"
    : undefined;

  const formatDateAno = (dateUtc: string) => {
    if (dateUtc) {
      let month = new Date(dateUtc).toLocaleString("pt-BR", { month: "long" });
      month = month.charAt(0).toUpperCase() + month.slice(1);
      return month + " " + new Date(dateUtc).getFullYear().toString();
    }
    return "";
  };

  const getTitleUrlPart = (url: string) => {
    if (url.indexOf("/Jornal Forluz/") > 0) return "Jornal da Forluz";
    if (url.indexOf("/Newsletter/") > 0) return "Newsletter";
    if (url.indexOf("/Rentabilidades/") > 0) return "Rentabilidades";
    if (url.indexOf("/Informe Taesaprev/") > 0) return "Informe Taesaprev";
    if (url.indexOf("/Revista Lume/") > 0) return "Revista Lume";
    return "";
  };

  const getIconeType = (url: string) => {
    if (url.indexOf("/Jornal Forluz/") > 0) return iconJornal;
    if (url.indexOf("/Newsletter/") > 0) return icoAviao;
    if (url.indexOf("/Rentabilidades/") > 0) return icoRentab;
    return icoSorriso;
  };

  return (
    <div className="publicacao-card">
      <a
        href={item.URL}
        className="publicacao-card-link"
        onClick={() => {
          if (!tipoPublicacao) return;

          track("publicacao_download", {
            identificador: `${tipoPublicacao}_${item.ID}`,
            tipo_publicacao: tipoPublicacao,
          });
        }}
      >
        {/* Header do Card */}
        <div className="publicacao-card-header">
          <div className="publicacao-card-number">
            Nº {item.ID} - {formatDateAno(item.Data_x0020_Publicacao)}
          </div>
          <div className="publicacao-card-category">
            {getTitleUrlPart(item.URL)}
          </div>
          <div className="publicacao-card-title">{item.Title}</div>
        </div>

        {/* Imagem do Card */}
        <div className="publicacao-card-image">
          <img src={getIconeType(item.URL)} alt="Ícone da publicação" />
        </div>

        {/* Descrição do Card */}
        <div className="publicacao-card-description">
          <p>{item.Descricao}</p>
        </div>

        {/* Link do Card (apenas desktop) */}
        <div className="publicacao-card-link-icon">
          <svg
            width="10" 
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 1V9"
              stroke="#e87400"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 5H9"
              stroke="#e87400"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </a>
    </div>
  );
};

export default PublicacaoCard;
